export default __webpack_public_path__ + "static/media/m-gif-2.97fe8b9e.gif";